const SCALE_STEPS = [1, 2, 3]

type Props = {
  isDarkMode: boolean
  scale: number
  onApplyScale: (value: number) => void
  onClose: () => void
}

export const ZoomModalHeader = ({ isDarkMode, scale, onApplyScale, onClose }: Props) => (
  <div
    className={`flex flex-wrap items-center justify-between gap-2 border-b px-4 py-3 ${
      isDarkMode ? 'border-slate-700' : 'border-slate-200'
    }`}
  >
    <p className={`text-xs font-semibold uppercase tracking-wide ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
      Zoom immagine prodotto
    </p>
    <div className="flex items-center gap-2">
      <div
        className={`flex items-center gap-1 rounded-full border p-1 ${
          isDarkMode ? 'border-slate-600 bg-slate-800' : 'border-slate-300 bg-slate-100'
        }`}
      >
        {SCALE_STEPS.map((step) => (
          <button
            key={step}
            type="button"
            onClick={() => onApplyScale(step)}
            className={`rounded-full px-2.5 py-1 text-xs font-semibold transition ${
              Math.abs(scale - step) < 0.01
                ? 'text-white'
                : isDarkMode
                ? 'text-slate-200 hover:bg-slate-700'
                : 'text-slate-700 hover:bg-slate-200'
            }`}
            style={
              Math.abs(scale - step) < 0.01 ? { background: 'var(--theme-color-primary, #10b981)' } : undefined
            }
          >
            {step}x
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={onClose}
        className={`rounded-full border px-3 py-1 text-xs font-semibold ${
          isDarkMode
            ? 'border-slate-600 text-slate-100 hover:border-slate-500'
            : 'border-slate-300 text-slate-700 hover:border-slate-400'
        }`}
      >
        Chiudi
      </button>
    </div>
  </div>
)
